









































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ClasificacionPatentes } from './ClasificacionPatentesService';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { FlotaFilterI, VehiculoFilterI } from '@/interfaces/Filters';
//import FlotaFilterAutocomplete from '@/components/Filters/FlotaFilterAutocomplete.vue';
import { LoadingService } from '@/services/loadingService';
import {
  DataAsociadaDispositivoI,
  DataBitacoraI,
  DataClasificadaI,
  EsquemaFlotaI,
  FlotasI,
  Flotas,
} from './ClasificacionPatentesInterfaces';

@Component({
  components: {
    //FlotaFilterAutocomplete,
  },
})
export default class ClasificacionPatenteModal extends Vue {
  clasificacionPatentes = new ClasificacionPatentes();
  headers: string[];
  desserts: string[];
  idCamara: string = '';
  step: number = 0;
  itemsFlota: DataAsociadaDispositivoI[] = [];
  itemsCodVehiculo: VehiculoFilterI[] = [];
  flota: string = '';
  allFlota: any[] = [{ id: '', nombre: '' }];
  cliente: string = '';
  allClientes: any[] = [{ id: '', nombre: '' }];
  labelStepper: string = 'Seleccione una flota y un vehículo';

  flota_selected: any[] = [{ id: '', nombre: '' }];
  itemsEsquemas: string[] = [];
  esquemaSelected: string = '';
  codVehiculoSelected: VehiculoFilterI = {
    id: '',
    cod_vehiculo: '',
    cod_flota: '',
    patente_vehiculo: '',
  };
  isDisabledBoton: boolean = true;
  continuarBoton1: boolean = true;
  continuarBoton2: boolean = true;
  dataSend: any = {};
  nom_flota!: DataAsociadaDispositivoI;
  $snotify: any;

  dataBitacora: DataBitacoraI = {
    user_id: this.currentUser,
  };

  isDialogOpen: boolean = false;
  isClosed: boolean = false;

  patentes_existentes: any[] = [];
  patentes_existentes_selected: any[] = [];
  showPatentesAsignadas: boolean = false;
  tipoAsignacion: string = '';
  nombreFlotaSeleccionada: string = '';
  nombreClienteSeleccionado: string = '';
  descPatentesExistentes: string = '';
  nro_serie: string = '';
  suf_patente: string = '';
  rotulo: string = '';
  esquemas: string = '';

  readonly loadingService = new LoadingService();

  @Prop() triggerDialogOpen: boolean = false;
  @Prop() dataGrid: any;
  @Prop({ default: false }) isConfiguration: boolean;

  @Watch('isConfiguration', { immediate: true })
  onModuleChanged() {
    this.labelStepper = this.isConfiguration
      ? 'Seleccione un Nro de serie y Sufijo de patente para el dispositivo'
      : 'Seleccione una flota y un vehiculo';
  }

  async open() {
    console.log(this.dataGrid);
    this.isDialogOpen = true;
    this.isClosed = false;
    this.idCamara = this.dataGrid.id_dispositivo;
    this.nro_serie = this.dataGrid.nro_serie;
    this.suf_patente = this.dataGrid.suf_patente;
    this.esquemas = this.dataGrid.esquemas;
    this.rotulo = this.dataGrid.rotulo;

    if (this.dataGrid.identifier !== undefined) {
      this.showPatentesAsignadas = true;
      this.patentes_existentes = this.dataGrid.identifier
        .split(',')
        .map((x: any) => {
          let y = x.split('##');
          return { id: y[1] + '__' + y[2], nombre: y[0] + ' - ' + y[3] };
        });
      this.patentes_existentes_selected = this.patentes_existentes.map(
        (x: any) => x.id
      );
    } else {
      this.showPatentesAsignadas = false;
    }
    await this.getAllFlotas();
    await this.getAllClientes();
    await this.loadSchema();
  }

  async loadSchema() {
    if (this.esquemas != '' || this.esquemas != undefined) {
      let formatSchema: string = '';
      console.log('Esquemas: ' + this.esquemas);
      let schemaList: string[] = this.esquemas.split(' ');
      for (let schema of schemaList) {
        formatSchema = schema.replaceAll("'", '').replaceAll('rut_', '');
        break;
      }
      console.log('formatSchema: ' + formatSchema);
      let client: any = this.allClientes.find((client: any) =>
        client.id.toString().includes(formatSchema)
      );
      console.log(client);
      if (client != undefined) {
        this.tipoAsignacion = 'cliente';
        this.cliente = client.id;
      }
    }
  }

  close() {
    this.step = 1;
    this.isClosed = true;
    this.flota = '';
    this.codVehiculoSelected = {
      id: '',
      cod_vehiculo: '',
      cod_flota: '',
      patente_vehiculo: '',
    };
    this.isDialogOpen = false;
    this.tipoAsignacion = '';
    this.patentes_existentes_selected = [];
    this.patentes_existentes = [];
    this.showPatentesAsignadas = false;
    this.descPatentesExistentes = '';
    this.nombreClienteSeleccionado = '';
    this.nombreFlotaSeleccionada = '';
    this.nro_serie = '';
    this.suf_patente = '';
    this.$emit('closeModal', false);
  }

  get currentUser() {
    return this.$store.state.user.id;
  }

  initStepDos() {
    // if (this.tipoAsignacion == 'cliente' && this.cliente == '') {
    //   this.$snotify.error('Debe seleccionar un cliente para asignar', {
    //     timeout: 3000,
    //   });
    //   return false;
    // }

    if (
      this.tipoAsignacion == 'flota' &&
      (this.flota == '' || this.codVehiculoSelected.id == '')
    ) {
      this.$snotify.error('Debe seleccionar una flota/patente para asignar', {
        timeout: 3000,
      });
      return false;
    }

    //this.showPatentesAsignadas = true;
    //this.patentes_existentes

    this.step = 2;
    //this.getEsquemaFlota(this.flota);
  }

  validationBoton1() {
    if (this.flota && this.codVehiculoSelected) {
      this.continuarBoton1 = false;
    }
  }

  validationBoton2() {
    if (this.esquemaSelected != '') {
      this.continuarBoton2 = false;
    }
  }

  async saveData() {
    //TODO change this
    this.dataSend = {
      id_camara: this.idCamara,
      patente: this.codVehiculoSelected.patente_vehiculo,
      flota: this.flota,
      cliente: this.cliente,
      tipoAsignacion: this.tipoAsignacion,
      patentes_existentes_selected: this.patentes_existentes_selected,
      nro_serie: this.nro_serie,
      suf_patente: this.suf_patente,
      rotulo: this.rotulo,
    };
    var axiosResponse: AxiosResponse<MSResponse<FlotasI>>;
    if (this.isConfiguration) {
      axiosResponse = await this.clasificacionPatentes.postDataConfig(
        this.dataSend
      );
    } else {
      axiosResponse = await this.clasificacionPatentes.postDataClasificada(
        this.dataSend
      );
    }
    const msResponse: MSResponse<FlotasI> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      this.close();
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  async getAllFlotas() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<Flotas>
    > = await this.clasificacionPatentes.getAllFlotas();
    const msResponse: MSResponse<Flotas> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.allFlota = msResponse.data;
      this.loadingService.hideLoading();
    } else {
      this.allFlota = [];
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
    }
  }

  async getAllClientes() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<Flotas>
    > = await this.clasificacionPatentes.getAllClientes();
    const msResponse: MSResponse<Flotas> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.allClientes = msResponse.data;
      this.loadingService.hideLoading();
    } else {
      this.allClientes = [];
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
    }
  }

  async getDataAsociadaDispositivo(idCamara: any) {
    const axiosResponse: AxiosResponse<
      MSResponse<DataAsociadaDispositivoI>
    > = await this.clasificacionPatentes.getDataAsociadaDispositivo(idCamara);
    const msResponse: MSResponse<DataAsociadaDispositivoI> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.itemsFlota = msResponse.data;
    } else {
      this.itemsFlota = [];
      this.itemsCodVehiculo = [];
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  async getEsquemaFlota(cod_flota: any) {
    const axiosResponse: AxiosResponse<
      MSResponse<EsquemaFlotaI>
    > = await this.clasificacionPatentes.getEsquemaFlota(cod_flota);
    const msResponse: MSResponse<EsquemaFlotaI> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.itemsEsquemas = msResponse.data.map(item => item.esquema_bd);
      if (this.itemsEsquemas[0] === '') {
        this.getEsquemaBD();
      }
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      //TODO agregar notificacion notify
    }
  }

  async getEsquemaBD() {
    const axiosResponse: AxiosResponse<
      MSResponse<EsquemaFlotaI>
    > = await this.clasificacionPatentes.getEsquemaBD();
    const msResponse: MSResponse<EsquemaFlotaI> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.itemsEsquemas = msResponse.data.map(item => item.esquema_bd);
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      //TODO agregar notificacion notify
    }
  }

  async getVehicles() {
    this.loadingService.showLoading();

    const axiosResponse: AxiosResponse<
      MSResponse<VehiculoFilterI>
    > = await this.clasificacionPatentes.getVehiculos(this.flota);
    const msResponse: MSResponse<VehiculoFilterI> = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.itemsCodVehiculo = msResponse.data;
      this.continuarBoton1 = false;
      this.loadingService.hideLoading();
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      //TODO agregar notificacion notify
      this.itemsCodVehiculo = [];
      this.continuarBoton1 = true;
      this.loadingService.hideLoading();
    }
  }

  @Watch('triggerDialogOpen')
  watchTriggerDialogOpen() {
    this.open();
  }

  watchFlota() {
    console.log('Presionó flota!!');
    console.log(this.isClosed);
    if (!this.isClosed) {
      let that = this;
      this.nombreFlotaSeleccionada = this.allFlota
        .filter((x: any) => x.id == that.flota)
        .map((x: any) => x.nombre)[0];
      this.getVehicles();
    } else {
      this.isClosed = false;
    }
  }

  @Watch('patentes_existentes_selected')
  watchPatExistentes() {
    let that = this;
    this.descPatentesExistentes = '';
    let arrayP = [];
    //for(let v of this.patentes_existentes_selected){
    //  this.descPatentesExistentes += ','+ this.patentes_existentes.filter( (x:any) => x.id==v.id).map( (x:any) =>x.nombre.split('-')[0]).toString();
    //}
    for (let v of this.patentes_existentes_selected) {
      arrayP.push(
        this.patentes_existentes
          .filter((x: any) => x.id == v)
          .map((x: any) => x.nombre.split('-')[0])[0]
      );
    }
    this.descPatentesExistentes = arrayP.join(', ');
  }

  @Watch('cliente')
  watchCliente() {
    let that = this;
    this.nombreClienteSeleccionado = this.allClientes
      .filter((x: any) => x.id == that.cliente)
      .map((x: any) => x.nombre)[0];
  }

  @Watch('tipoAsignacion')
  watchTipoAsignacion() {
    //console.log(this.tipoAsignacion);
  }
}
